import { render, staticRenderFns } from "./FlashMessage.vue?vue&type=template&id=39ad43ae"
import script from "./FlashMessage.vue?vue&type=script&lang=js"
export * from "./FlashMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39ad43ae')) {
      api.createRecord('39ad43ae', component.options)
    } else {
      api.reload('39ad43ae', component.options)
    }
    module.hot.accept("./FlashMessage.vue?vue&type=template&id=39ad43ae", function () {
      api.rerender('39ad43ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/messages/FlashMessage.vue"
export default component.exports